import { CSSProperties } from "react";

export const CardPreviewModalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  width: 280,
  transform: "translate(-50%, -50%)",
  "& .MuiCard-root": {
    boxShadow: "none",
    overflow: "inherit",
    backgroundImage: "none",
    backgroundColor: "transparent",
  },
};
export const CardPreviewModalImageStyle: CSSProperties = {
  boxSizing: "border-box",
  borderRadius: "4.75% / 3.5%",
  boxShadow: "1px 1px 8px rgb(0 0 0 / 50%)",
  height: "3.5in",
  width: "2.5in",
  objectFit: "cover",
};

export const CardPreviewSizing: CSSProperties = {
  width: "2.5in",
  height: "3.5in",
  minHeight: "3.5in",
  minWidth: "2.5in",
};
export const ChangePrintingCardSizing: CSSProperties = {
  width: "1.5in",
  height: "2.1in",
  borderRadius: "4.75% / 3.5%",
};

export const ResponsiveCardSizing: CSSProperties = {
  width: "100%",
  aspectRatio: "2.5/3.5",
};

// Card sizing for homepage mobile carousel - approximately 88% of standard size
export const HomepageCardSizing: CSSProperties = {
  width: "2.2in",
  height: "3.08in",
  minHeight: "3.08in",
  minWidth: "2.2in",
};

/**
 * Homepage city strips: a snap carousel on mobile, a 6-up grid from md.
 * HomepageCityCardsClient and HomepageCityCardsSkeleton must stay geometrically
 * identical or the page shifts when data lands, so both read these.
 */
export const HOMEPAGE_CAROUSEL_CLASSES =
  "carousel w-full gap-2 md:grid md:grid-cols-6 md:gap-3 md:overflow-x-visible";
export const HOMEPAGE_CAROUSEL_ITEM_CLASSES =
  "carousel-item w-[55%] sm:w-[38%] md:w-auto";

// Responsive version of homepage sizing
export const HomepageResponsiveCardSizing: CSSProperties = {
  width: "100%",
  height: "100%",
  aspectRatio: "2.5/3.5",
};

// Smaller card sizing for user profile grids - approximately 60% of standard size
export const ProfileCardSizing: CSSProperties = {
  width: "1.5in",
  height: "2.1in",
  minHeight: "2.1in",
  minWidth: "1.5in",
};

// Responsive version of profile card sizing
export const ProfileResponsiveCardSizing: CSSProperties = {
  width: "100%",
  height: "100%",
  aspectRatio: "2.5/3.5",
};
